import { render } from "./ModuleProductGallery.vue?vue&type=template&id=4b0a4dea"
import script from "./ModuleProductGallery.vue?vue&type=script&lang=js"
export * from "./ModuleProductGallery.vue?vue&type=script&lang=js"

import "./ModuleProductGallery.vue?vue&type=style&index=0&id=4b0a4dea&lang=scss"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__